var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecureInformation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16818",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12464",
    d: "M10 10.447h4a1 1 0 011 1V14.5a1 1 0 01-1 1h-4a1 1 0 01-1-1v-3.053a1 1 0 011-1z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12465",
    d: "M10.316 10.447V9.184a1.684 1.684 0 013.368 0v1.261"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12466",
    d: "M5.973 5.067l5.342-1.946a2 2 0 011.369 0l5.342 1.946A3 3 0 0120 7.886v4.872c0 3.581-1.828 5.05-7.005 7.981a2.022 2.022 0 01-1.99 0C5.828 17.808 4 16.339 4 12.758V7.886a3 3 0 011.973-2.819z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12467",
    d: "M0 0h24v24H0z",
    fill: "none"
  })));
}
export default SvgSecureInformation;


//////////////////
// WEBPACK FOOTER
// ./src/icons/secureInformation.svg
// module id = 248
// module chunks = 11